import { Node } from 'tiptap'
import SbpImage from '@/components/tiptap/extensions/SbpImage.vue'

export default class SbpImgNode extends Node {
    get name () {
        return 'sbp_image_node'
    }

    get schema () {
        return {
            // here you have to specify all values that can be stored in this node
            attrs: {
                relatedmediaid: {
                    default: null
                },
                align: {
                    default: null
                },
                alt: {
                    default: null
                },
                caption: {
                    default: null
                },
                credit: {
                    default: null
                },
                description: {
                    default: null
                },
                src: {
                    default: null
                },
                width: {
                    default: null
                },
                style: {
                    default: null
                },
                customClass: {
                    default: null
                },
            },
            group: 'block',
            content: 'inline*',
            draggable: true,
            // parseDOM and toDOM is still required to make copy and paste work
            parseDOM: [{
                tag: 'sbp-img',
                getAttrs: dom => ({
                    relatedmediaid: dom.getAttribute('relatedmediaid'),
                    align: dom.getAttribute('align'),
                    alt: dom.getAttribute('alt'),
                    caption: dom.getAttribute('caption'),
                    credit: dom.getAttribute('credit'),
                    description: dom.getAttribute('description'),
                    src: dom.getAttribute('src'),
                    width: dom.getAttribute('width'),
                    style: dom.getAttribute('style'),
                    customClass: dom.getAttribute('customClass'),
                }),
            }],
            toDOM: node => ['sbp-img', {
                relatedmediaid: node.attrs.relatedmediaid,
                align: node.attrs.align,
                alt: node.attrs.alt,
                caption: node.attrs.caption,
                credit: node.attrs.credit,
                description: node.attrs.description,
                src: node.attrs.src,
                width: node.attrs.width,
                style: node.attrs.style,
                class: node.attrs.customClass,
            }]
        }
    }
    commands ({ type }) {
        return (attrs) => (state, dispatch) => {
            dispatch(state.tr.replaceSelectionWith(type.create({
                'relatedmediaid': (attrs) ? attrs.relatedmediaid : null,
                'src': (attrs) ? attrs.src : null,
                'alt': (attrs) ? attrs.alt : null,
                'caption': (attrs) ? attrs.caption : null,
                'credit': (attrs) ? attrs.credit : null,
                'description': (attrs) ? attrs.description : null,
                'width': (attrs) ? attrs.width : null,
                'align': (attrs) ? attrs.align : null,
                'style': (attrs) ? attrs.style : null,
                'customClass': (attrs) ? attrs.customClass : null,
            })))
        }
    }

    get view () {
        return SbpImage
    }
}
